import React from "react";
import { Button } from "@sscs/ui";
import { LoginContentWrapper } from "Components";
import { SamlSsoLoginInfo } from "Types";
import EulaLink from "../EulaLink/EulaLink";
import SupportLoginLink from "../SupportLoginLink/SupportLoginLink";

type SAMLLoginProps = {
  ssoInfo: SamlSsoLoginInfo;
};

const SAMLLogin = ({ ssoInfo }: SAMLLoginProps): React.JSX.Element => {
  const handleSAMLLogin = (): void => {
    window.location.href = ssoInfo.sso_login_endpoint;
  };

  return (
    <LoginContentWrapper
      title="SSO login"
      byline="Your organization has enabled SSO so you can log in quickly and easily with your corporate account"
    >
      <Button
        isFullWidth
        onClick={handleSAMLLogin}
        color="primary"
        size="large"
      >
        Log in with SSO
      </Button>
      <EulaLink />
      <SupportLoginLink />
    </LoginContentWrapper>
  );
};

export default SAMLLogin;
